import {
  ConnectionListResult,
  FeatureFlagsContext,
  GridSortProps,
  PaginatedQueryWrapper
} from '@tableau/data-catalog-shared';
import * as React from 'react';

import {
  DatabasesByTagQuery,
  DatabasesByTagQuery_tags_databasesConnection_nodes,
  DatabasesByTagQueryVariables,
} from '../../../gen-src/queries/DatabasesByTagQuery';
import {
  DatabasesQuery,
  DatabasesQuery_databasesConnection_nodes,
  DatabasesQueryVariables,
} from '../../../gen-src/queries/DatabasesQuery';
import { DatabaseSortOrder } from '../../../gen-src/queries/globalTypes';
import { DatabasesQueryGql } from '../../queries/DatabasesQueryGql';
import { getRowDataWithMaxCountsForDatabase } from '../database/functions/DatabaseRowDataFunctions';
import { DatabasesDisplayGridRowData } from '../database/types/DatabasesDisplayGridRowData';
import { DatabasesDisplayGrid } from '../sharedDisplayGrid/DatabasesDisplayGrid';
import { DatabasesValidSortFields } from '../sorting/sortProviders/DatabasesGridSortProvider';

export type QueryVariables = DatabasesQueryVariables;
export type QueryResults = DatabasesQuery;
export type QueryResultListNode = DatabasesQuery_databasesConnection_nodes;

export type QueryVariablesWithTagFilter = DatabasesByTagQueryVariables;
export type QueryResultsWithTagFilter = DatabasesByTagQuery;
export type QueryResultListNodeWithTagFilter = DatabasesByTagQuery_tags_databasesConnection_nodes;

export type GridRowData = DatabasesDisplayGridRowData;

export function selectConnectionListResult(resultData: QueryResults): ConnectionListResult<QueryResultListNode> | null {
  return resultData && resultData.databasesConnection;
}

export function selectConnectionListResultWithTagFilter(
  resultData: QueryResultsWithTagFilter
): ConnectionListResult<QueryResultListNodeWithTagFilter> | null {
  return resultData && resultData.tags && resultData.tags[0].databasesConnection;
}

export type DatabasesExplorerQueryGridProps = GridSortProps<DatabasesValidSortFields>;

// This component is used only from the example. In the actual app, we render the Databases Explorer via
// VizPortal's "Explorer" instead, using these result mappers and the columns from the DatabasesDisplayGrid.
export function DatabasesExplorerQueryGrid(props: DatabasesExplorerQueryGridProps): JSX.Element {
  const { publishedConnectionsLineageEnabled } = React.useContext(FeatureFlagsContext);
  return (
    <PaginatedQueryWrapper<QueryVariables, QueryResults, QueryResultListNode, GridRowData>
      queryGql={DatabasesQueryGql}
      partialQueryVariables={{ orderBy: props.orderBy as DatabaseSortOrder, publishedConnectionsLineageEnabled }}
      selectConnectionListResult={selectConnectionListResult}
      mapResultNode={getRowDataWithMaxCountsForDatabase}
    >
      {({ rowStore }) => (
        <DatabasesDisplayGrid
          rowStore={rowStore}
          orderBy={props.orderBy}
          updateSortOrder={props.updateSortOrder}
        />
      )}
    </PaginatedQueryWrapper>
  );
}
